import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { GeneralFeedbackComponent } from '@nk/shared/components/feedback/general-feedback/general-feedback.component';

@Component({
  selector: 'nk-feedback-button',
  templateUrl: './feedback-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FeedbackButtonComponent {
  constructor(private _modalService: BsModalService) {}
  @Input() public label = null;
  @Input() public andClass = '';

  public openModal(): void {
    this._modalService.show(GeneralFeedbackComponent);
  }
}
